module.exports = __webpack_public_path__ + "img/product-siwei-siwei.c893ae63.jpg";